module.exports = __webpack_public_path__ + "img/monitoring.7af8cb6.svg";